import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, withCtx as _withCtx, unref as _unref, resolveComponent as _resolveComponent, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = /*#__PURE__*/_createVNode("i", { class: "pi pi-pencil" }, null, -1)
const _hoisted_2 = { class: "modal-content p-mb-6" }
const _hoisted_3 = { class: "p-d-flex p-flex-column gap-20" }
const _hoisted_4 = { class: "flexbox-row gap-40" }
const _hoisted_5 = { class: "flex-1" }
const _hoisted_6 = { class: "flex-1" }
const _hoisted_7 = { class: "flexbox-row gap-40" }
const _hoisted_8 = { class: "p-field-checkbox" }
const _hoisted_9 = {
  for: "kit_delivery",
  class: "color-white montserrat font-13"
}
const _hoisted_10 = {
  key: 0,
  class: "p-field-checkbox"
}
const _hoisted_11 = {
  for: "auto_renewal",
  class: "color-white montserrat font-13"
}
const _hoisted_12 = { class: "p-d-flex" }

import {
  Membership,
  UpdateMembershipDtoStatusEnum,
} from "@/generated-sources/anagrafica-api";
import { ref } from "vue";
import { useI18n } from "vue-i18n";
import UiAutocomplete from "../ui/UiAutocomplete.vue";
import UiButton from "../ui/UiButton.vue";
import { client } from "@/api/client-v2";
import moment from "moment-timezone";
import { showSuccessToast, showToast } from "@/services/error-management.service";

interface Props {
  membership: Membership;
}


export default _defineComponent({
  props: {
    membership: { type: null, required: true }
  } as unknown as undefined,
  emits: ['updated', 'updating'],
  setup(__props: {
  membership: Membership;
}, { emit }) {

const props = __props
const { t } = useI18n();



const show = ref(false);

const formData = ref({
  status: props.membership.status as UpdateMembershipDtoStatusEnum, // la tipizzazione è da correggere
  expirationDate: new Date(props.membership.expirationDate),
  welcomeKitDelivered: props.membership.welcomeKitDelivered,
  autoRenewal: props.membership.autoRenewal,
  description: props.membership.description,
  notes: props.membership.notes,
  price: isNaN(props.membership.price) ? null : props.membership.price / 100,
});

const statusMembershipOptions: { label: string; value: UpdateMembershipDtoStatusEnum; disabled: boolean }[] = [
  { label: t('active'), value: 'active', disabled: false },
  { label: t('suspended'), value: 'suspended', disabled: false },
  { label: t('cancelled'), value: 'cancelled', disabled: false }
];

const saveMembership = async () => {
  emit('updating');
  const formatMembershipRequest = {
    ...formData.value,
    expirationDate: moment(formData.value.expirationDate).toISOString(),
    price: (typeof formData.value.price === 'string' ? parseFloat(formData.value.price) : (formData.value.price || 0)) * 100
  }
  try {
    show.value = false;
    const request = await client.updateMembership({
      membershipId: props.membership.id,
      membership: { ...formatMembershipRequest }
    })
    showSuccessToast('Membership aggiornata con successo');
  } catch {
    showToast();
  } finally {
    emit('updated')
  }
}

return (_ctx: any,_cache: any) => {
  const _component_PadelInput = _resolveComponent("PadelInput")!
  const _component_PadelCalendar = _resolveComponent("PadelCalendar")!
  const _component_Checkbox = _resolveComponent("Checkbox")!
  const _component_PadelTextarea = _resolveComponent("PadelTextarea")!
  const _component_DumbModal = _resolveComponent("DumbModal")!

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode(UiButton, {
      variant: "primary",
      "is-text": "",
      onClick: _cache[1] || (_cache[1] = () => show.value = true)
    }, {
      default: _withCtx(() => [
        _hoisted_1
      ]),
      _: 1
    }),
    (show.value)
      ? (_openBlock(), _createBlock(_component_DumbModal, {
          key: 0,
          title: _unref(t)('edit_membership'),
          onHide: _cache[10] || (_cache[10] = () => show.value = false)
        }, {
          footer: _withCtx(() => [
            _createVNode("div", _hoisted_12, [
              _createVNode(UiButton, {
                variant: "secondary",
                "is-text": "",
                onClick: _cache[9] || (_cache[9] = () => show.value = false)
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)('annulla')), 1)
                ]),
                _: 1
              }),
              _createVNode(UiButton, {
                variant: 'primary',
                onClick: saveMembership,
                class: "p-ml-auto"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)('save')), 1)
                ]),
                _: 1
              })
            ])
          ]),
          default: _withCtx(() => [
            _createVNode("div", _hoisted_2, [
              _createVNode("div", _hoisted_3, [
                _createVNode("div", null, [
                  _createVNode(_component_PadelInput, {
                    value: props.membership.userNome + ' ' + props.membership.userCognome,
                    readonly: "",
                    disabled: ""
                  }, null, 8, ["value"])
                ]),
                _createVNode("div", null, [
                  _createVNode(UiAutocomplete, {
                    label: _unref(t)('stato_membership'),
                    options: statusMembershipOptions,
                    modelValue: formData.value.status,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (formData.value.status = $event))
                  }, null, 8, ["label", "modelValue"])
                ]),
                _createVNode("div", _hoisted_4, [
                  _createVNode("div", _hoisted_5, [
                    _createVNode(_component_PadelCalendar, {
                      label: _unref(t)('activation_date'),
                      value: new Date(props.membership.activationDate),
                      readonly: "",
                      disabled: ""
                    }, null, 8, ["label", "value"])
                  ]),
                  _createVNode("div", _hoisted_6, [
                    _createVNode(_component_PadelCalendar, {
                      label: _unref(t)('expiration_date') + '*',
                      value: formData.value.expirationDate,
                      "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => (formData.value.expirationDate = $event))
                    }, null, 8, ["label", "value"])
                  ])
                ]),
                _createVNode("div", _hoisted_7, [
                  _createVNode("div", _hoisted_8, [
                    _createVNode(_component_Checkbox, {
                      id: "kit_delivery",
                      modelValue: formData.value.welcomeKitDelivered,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (formData.value.welcomeKitDelivered = $event)),
                      binary: true
                    }, null, 8, ["modelValue"]),
                    _createVNode("label", _hoisted_9, _toDisplayString(_unref(t)('kit_delivery')), 1)
                  ]),
                  (props.membership.paymentMethod === 'CARD')
                    ? (_openBlock(), _createBlock("div", _hoisted_10, [
                        _createVNode(_component_Checkbox, {
                          id: "auto_renewal",
                          modelValue: formData.value.autoRenewal,
                          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (formData.value.autoRenewal = $event)),
                          binary: true
                        }, null, 8, ["modelValue"]),
                        _createVNode("label", _hoisted_11, _toDisplayString(_unref(t)('auto_renewal')), 1)
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _createVNode("div", null, [
                  _createVNode(_component_PadelTextarea, {
                    label: _unref(t)('description') + '*',
                    value: formData.value.description,
                    "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => (formData.value.description = $event))
                  }, null, 8, ["label", "value"])
                ]),
                _createVNode("div", null, [
                  _createVNode(_component_PadelTextarea, {
                    label: _unref(t)('notes'),
                    value: formData.value.notes,
                    "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => (formData.value.notes = $event))
                  }, null, 8, ["label", "value"])
                ]),
                _createVNode("div", null, [
                  _createVNode(_component_PadelInput, {
                    label: _unref(t)('price') + '*',
                    type: "number",
                    value: formData.value.price,
                    "onUpdate:value": _cache[8] || (_cache[8] = ($event: any) => (formData.value.price = $event))
                  }, null, 8, ["label", "value"])
                ])
              ])
            ])
          ]),
          _: 1
        }, 8, ["title"]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})